import React, { Fragment } from "react";
import useForm from "../../../../hooks/useForm";
import Input from "../../../form/Input";
import Button from "../../../form/Button";
import { otpVerification } from "../../../../services/authService";
import useMutation from "../../../../hooks/useMutation";
import { toast } from "react-toastify";
import OtpInput from "../../../form/OtpInput";
import { useNavigate } from "react-router-dom";

const validation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  otp: { required: true, message: "Please Enter Valid Otp" },
};

const OtpVerificationForm = () => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  const navigate = useNavigate();

  const {
    mutate,
    error: signUpError,
    isPending: signUpPending,
    data: signUpData,
  } = useMutation({
    mutationFn: async (val) => {
      return await otpVerification({
        ...val,
      });
    },
    onSuccess: async (res) => {
      if (res?.status === 200) {
        navigate("/authentication");
      } else {
        toast.warning(res?.message);
      }
    },
  });

  return (
    <form
      className="space-y-4"
      onSubmit={(event) => handleSubmit(event, mutate)}
    >
      <Fragment>
        <div className="relative">
          <Input
            label={"Email Address"}
            inputPlaceholder={"Enter Email Address"}
            labelClasses={"!text-white !text-base"}
            inputClasses={
              "!h-12 !rounded-lg !border-white !bg-transparent !text-white placeholder:!text-white focus:!border-chestnut-rose"
            }
            inputType={"email"}
            inputName="email"
            value={values?.email}
            onChange={handleChange}
            {...formValidate(errors, "email")}
          />
        </div>
        <div className="relative">
          <OtpInput
            label={"Enter OTP"}
            handleOtpChange={(val) =>
              handleChange({
                target: { value: val, name: "otp" },
              })
            }
            inputName="otp"
            labelChildClass={
              "!h-12 !rounded-lg !border-white !bg-transparent !text-white placeholder:!text-white focus:!border-chestnut-rose"
            }
            {...formValidate(errors, "otp")}
          />
        </div>
      </Fragment>
      <div className="relative">
        <Button
          buttonLabel={"Verify"}
          buttonType="submit"
          buttonLabelClasses={"!text-lg !font-semibold"}
          buttonClasses={"!w-full !h-12 !rounded-lg"}
          loading={signUpPending}
          isDisable={signUpPending}
          buttonIconPosition="left"
        />
      </div>
    </form>
  );
};

export default OtpVerificationForm;
